/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BookingBaseService } from '../booking-base-service';
import { BookingApiConfiguration } from '../booking-api-configuration';
import { BookingStrictHttpResponse } from '../booking-strict-http-response';

import { apiAdminPingGet } from '../fn/admin/api-admin-ping-get';
import { ApiAdminPingGet$Params } from '../fn/admin/api-admin-ping-get';
import { apiAdminTriggerFhirSyncPost } from '../fn/admin/api-admin-trigger-fhir-sync-post';
import { ApiAdminTriggerFhirSyncPost$Params } from '../fn/admin/api-admin-trigger-fhir-sync-post';

@Injectable({ providedIn: 'root' })
export class BookingAdminService extends BookingBaseService {
  constructor(config: BookingApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAdminPingGet()` */
  static readonly ApiAdminPingGetPath = '/api/Admin/Ping';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminPingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminPingGet$Response(params?: ApiAdminPingGet$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<void>> {
    return apiAdminPingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminPingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminPingGet(params?: ApiAdminPingGet$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminPingGet$Response(params, context).pipe(
      map((r: BookingStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminTriggerFhirSyncPost()` */
  static readonly ApiAdminTriggerFhirSyncPostPath = '/api/Admin/TriggerFhirSync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminTriggerFhirSyncPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminTriggerFhirSyncPost$Response(params?: ApiAdminTriggerFhirSyncPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<void>> {
    return apiAdminTriggerFhirSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminTriggerFhirSyncPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminTriggerFhirSyncPost(params?: ApiAdminTriggerFhirSyncPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminTriggerFhirSyncPost$Response(params, context).pipe(
      map((r: BookingStrictHttpResponse<void>): void => r.body)
    );
  }

}
